import { createSelector } from 'reselect';
import { State } from '.';
import {
    SnomedCategory,
    SnomedCategoryType
} from '../../models/snomed-category';

const checkLoadedSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<SnomedCategory>) => Object.keys(byId).length > 0
);

export const selectors = {
    checkLoaded: (
        state: State
    ): boolean => checkLoadedSelector(state),
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getSnomedCategory: (
        state: State,
        code: Undefinable<DictionaryKey>
    ): Undefinable<SnomedCategory> => state.byId[code || ''],
    getSnomedCategoryIds: (
        state: State,
        type: SnomedCategoryType
    ): Undefinable<number[]> => state.byType[type]
};
